import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import { Mail, Lock, Eye, EyeOff, User, Building, Phone, UserPlus, Globe, ChevronDown } from 'lucide-react';
import { useSettings } from '../hooks/useSettings';

const Register = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    fullName: '',
    companyName: '',
    phoneNumber: '',
    countryCode: '+1'
  });
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [countrySearch, setCountrySearch] = useState('');
  const [isDetectingLocation, setIsDetectingLocation] = useState(true);
  
  const countryCodes = [
    { code: '+93', country: 'AF', flag: '🇦🇫', name: 'Afghanistan' },
    { code: '+355', country: 'AL', flag: '🇦🇱', name: 'Albania' },
    { code: '+213', country: 'DZ', flag: '🇩🇿', name: 'Algeria' },
    { code: '+1684', country: 'AS', flag: '🇦🇸', name: 'American Samoa' },
    { code: '+376', country: 'AD', flag: '🇦🇩', name: 'Andorra' },
    { code: '+244', country: 'AO', flag: '🇦🇴', name: 'Angola' },
    { code: '+1264', country: 'AI', flag: '🇦🇮', name: 'Anguilla' },
    { code: '+672', country: 'AQ', flag: '🇦🇶', name: 'Antarctica' },
    { code: '+1268', country: 'AG', flag: '🇦🇬', name: 'Antigua and Barbuda' },
    { code: '+54', country: 'AR', flag: '🇦🇷', name: 'Argentina' },
    { code: '+374', country: 'AM', flag: '🇦🇲', name: 'Armenia' },
    { code: '+297', country: 'AW', flag: '🇦🇼', name: 'Aruba' },
    { code: '+61', country: 'AU', flag: '🇦🇺', name: 'Australia' },
    { code: '+43', country: 'AT', flag: '🇦🇹', name: 'Austria' },
    { code: '+994', country: 'AZ', flag: '🇦🇿', name: 'Azerbaijan' },
    { code: '+1242', country: 'BS', flag: '🇧🇸', name: 'Bahamas' },
    { code: '+973', country: 'BH', flag: '🇧🇭', name: 'Bahrain' },
    { code: '+880', country: 'BD', flag: '🇧🇩', name: 'Bangladesh' },
    { code: '+1246', country: 'BB', flag: '🇧🇧', name: 'Barbados' },
    { code: '+375', country: 'BY', flag: '🇧🇾', name: 'Belarus' },
    { code: '+32', country: 'BE', flag: '🇧🇪', name: 'Belgium' },
    { code: '+501', country: 'BZ', flag: '🇧🇿', name: 'Belize' },
    { code: '+229', country: 'BJ', flag: '🇧🇯', name: 'Benin' },
    { code: '+1441', country: 'BM', flag: '🇧🇲', name: 'Bermuda' },
    { code: '+975', country: 'BT', flag: '🇧🇹', name: 'Bhutan' },
    { code: '+591', country: 'BO', flag: '🇧🇴', name: 'Bolivia' },
    { code: '+387', country: 'BA', flag: '🇧🇦', name: 'Bosnia and Herzegovina' },
    { code: '+267', country: 'BW', flag: '🇧🇼', name: 'Botswana' },
    { code: '+55', country: 'BR', flag: '🇧🇷', name: 'Brazil' },
    { code: '+246', country: 'IO', flag: '🇮🇴', name: 'British Indian Ocean Territory' },
    { code: '+673', country: 'BN', flag: '🇧🇳', name: 'Brunei' },
    { code: '+359', country: 'BG', flag: '🇧🇬', name: 'Bulgaria' },
    { code: '+226', country: 'BF', flag: '🇧🇫', name: 'Burkina Faso' },
    { code: '+257', country: 'BI', flag: '🇧🇮', name: 'Burundi' },
    { code: '+855', country: 'KH', flag: '🇰🇭', name: 'Cambodia' },
    { code: '+237', country: 'CM', flag: '🇨🇲', name: 'Cameroon' },
    { code: '+1', country: 'CA', flag: '🇨🇦', name: 'Canada' },
    { code: '+238', country: 'CV', flag: '🇨🇻', name: 'Cape Verde' },
    { code: '+1345', country: 'KY', flag: '🇰🇾', name: 'Cayman Islands' },
    { code: '+236', country: 'CF', flag: '🇨🇫', name: 'Central African Republic' },
    { code: '+235', country: 'TD', flag: '🇹🇩', name: 'Chad' },
    { code: '+56', country: 'CL', flag: '🇨🇱', name: 'Chile' },
    { code: '+86', country: 'CN', flag: '🇨🇳', name: 'China' },
    { code: '+61', country: 'CX', flag: '🇨🇽', name: 'Christmas Island' },
    { code: '+61', country: 'CC', flag: '🇨🇨', name: 'Cocos Islands' },
    { code: '+57', country: 'CO', flag: '🇨🇴', name: 'Colombia' },
    { code: '+269', country: 'KM', flag: '🇰🇲', name: 'Comoros' },
    { code: '+243', country: 'CD', flag: '🇨🇩', name: 'Congo (DRC)' },
    { code: '+242', country: 'CG', flag: '🇨🇬', name: 'Congo (Republic)' },
    { code: '+682', country: 'CK', flag: '🇨🇰', name: 'Cook Islands' },
    { code: '+506', country: 'CR', flag: '🇨🇷', name: 'Costa Rica' },
    { code: '+225', country: 'CI', flag: '🇨🇮', name: 'Côte d\'Ivoire' },
    { code: '+385', country: 'HR', flag: '🇭🇷', name: 'Croatia' },
    { code: '+53', country: 'CU', flag: '🇨🇺', name: 'Cuba' },
    { code: '+599', country: 'CW', flag: '🇨🇼', name: 'Curaçao' },
    { code: '+357', country: 'CY', flag: '🇨🇾', name: 'Cyprus' },
    { code: '+420', country: 'CZ', flag: '🇨🇿', name: 'Czech Republic' },
    { code: '+45', country: 'DK', flag: '🇩🇰', name: 'Denmark' },
    { code: '+253', country: 'DJ', flag: '🇩🇯', name: 'Djibouti' },
    { code: '+1767', country: 'DM', flag: '🇩🇲', name: 'Dominica' },
    { code: '+1809', country: 'DO', flag: '🇩🇴', name: 'Dominican Republic' },
    { code: '+593', country: 'EC', flag: '🇪🇨', name: 'Ecuador' },
    { code: '+20', country: 'EG', flag: '🇪🇬', name: 'Egypt' },
    { code: '+503', country: 'SV', flag: '🇸🇻', name: 'El Salvador' },
    { code: '+240', country: 'GQ', flag: '🇬🇶', name: 'Equatorial Guinea' },
    { code: '+291', country: 'ER', flag: '🇪🇷', name: 'Eritrea' },
    { code: '+372', country: 'EE', flag: '🇪🇪', name: 'Estonia' },
    { code: '+251', country: 'ET', flag: '🇪🇹', name: 'Ethiopia' },
    { code: '+500', country: 'FK', flag: '🇫🇰', name: 'Falkland Islands' },
    { code: '+298', country: 'FO', flag: '🇫🇴', name: 'Faroe Islands' },
    { code: '+679', country: 'FJ', flag: '🇫🇯', name: 'Fiji' },
    { code: '+358', country: 'FI', flag: '🇫🇮', name: 'Finland' },
    { code: '+33', country: 'FR', flag: '🇫🇷', name: 'France' },
    { code: '+594', country: 'GF', flag: '🇬🇫', name: 'French Guiana' },
    { code: '+689', country: 'PF', flag: '🇵🇫', name: 'French Polynesia' },
    { code: '+241', country: 'GA', flag: '🇬🇦', name: 'Gabon' },
    { code: '+220', country: 'GM', flag: '🇬🇲', name: 'Gambia' },
    { code: '+995', country: 'GE', flag: '🇬🇪', name: 'Georgia' },
    { code: '+49', country: 'DE', flag: '🇩🇪', name: 'Germany' },
    { code: '+233', country: 'GH', flag: '🇬🇭', name: 'Ghana' },
    { code: '+350', country: 'GI', flag: '🇬🇮', name: 'Gibraltar' },
    { code: '+30', country: 'GR', flag: '🇬🇷', name: 'Greece' },
    { code: '+299', country: 'GL', flag: '🇬🇱', name: 'Greenland' },
    { code: '+1473', country: 'GD', flag: '🇬🇩', name: 'Grenada' },
    { code: '+590', country: 'GP', flag: '🇬🇵', name: 'Guadeloupe' },
    { code: '+1671', country: 'GU', flag: '🇬🇺', name: 'Guam' },
    { code: '+502', country: 'GT', flag: '🇬🇹', name: 'Guatemala' },
    { code: '+44', country: 'GG', flag: '🇬🇬', name: 'Guernsey' },
    { code: '+224', country: 'GN', flag: '🇬🇳', name: 'Guinea' },
    { code: '+245', country: 'GW', flag: '🇬🇼', name: 'Guinea-Bissau' },
    { code: '+592', country: 'GY', flag: '🇬🇾', name: 'Guyana' },
    { code: '+509', country: 'HT', flag: '🇭🇹', name: 'Haiti' },
    { code: '+504', country: 'HN', flag: '🇭🇳', name: 'Honduras' },
    { code: '+852', country: 'HK', flag: '🇭🇰', name: 'Hong Kong' },
    { code: '+36', country: 'HU', flag: '🇭🇺', name: 'Hungary' },
    { code: '+354', country: 'IS', flag: '🇮🇸', name: 'Iceland' },
    { code: '+91', country: 'IN', flag: '🇮🇳', name: 'India' },
    { code: '+62', country: 'ID', flag: '🇮🇩', name: 'Indonesia' },
    { code: '+98', country: 'IR', flag: '🇮🇷', name: 'Iran' },
    { code: '+964', country: 'IQ', flag: '🇮🇶', name: 'Iraq' },
    { code: '+353', country: 'IE', flag: '🇮🇪', name: 'Ireland' },
    { code: '+44', country: 'IM', flag: '🇮🇲', name: 'Isle of Man' },
    { code: '+972', country: 'IL', flag: '🇮🇱', name: 'Israel' },
    { code: '+39', country: 'IT', flag: '🇮🇹', name: 'Italy' },
    { code: '+1876', country: 'JM', flag: '🇯🇲', name: 'Jamaica' },
    { code: '+81', country: 'JP', flag: '🇯🇵', name: 'Japan' },
    { code: '+44', country: 'JE', flag: '🇯🇪', name: 'Jersey' },
    { code: '+962', country: 'JO', flag: '🇯🇴', name: 'Jordan' },
    { code: '+7', country: 'KZ', flag: '🇰🇿', name: 'Kazakhstan' },
    { code: '+254', country: 'KE', flag: '🇰🇪', name: 'Kenya' },
    { code: '+686', country: 'KI', flag: '🇰🇮', name: 'Kiribati' },
    { code: '+850', country: 'KP', flag: '🇰🇵', name: 'North Korea' },
    { code: '+82', country: 'KR', flag: '🇰🇷', name: 'South Korea' },
    { code: '+965', country: 'KW', flag: '🇰🇼', name: 'Kuwait' },
    { code: '+996', country: 'KG', flag: '🇰🇬', name: 'Kyrgyzstan' },
    { code: '+856', country: 'LA', flag: '🇱🇦', name: 'Laos' },
    { code: '+371', country: 'LV', flag: '🇱🇻', name: 'Latvia' },
    { code: '+961', country: 'LB', flag: '🇱🇧', name: 'Lebanon' },
    { code: '+266', country: 'LS', flag: '🇱🇸', name: 'Lesotho' },
    { code: '+231', country: 'LR', flag: '🇱🇷', name: 'Liberia' },
    { code: '+218', country: 'LY', flag: '🇱🇾', name: 'Libya' },
    { code: '+423', country: 'LI', flag: '🇱🇮', name: 'Liechtenstein' },
    { code: '+370', country: 'LT', flag: '🇱🇹', name: 'Lithuania' },
    { code: '+352', country: 'LU', flag: '🇱🇺', name: 'Luxembourg' },
    { code: '+853', country: 'MO', flag: '🇲🇴', name: 'Macau' },
    { code: '+389', country: 'MK', flag: '🇲🇰', name: 'North Macedonia' },
    { code: '+261', country: 'MG', flag: '🇲🇬', name: 'Madagascar' },
    { code: '+265', country: 'MW', flag: '🇲🇼', name: 'Malawi' },
    { code: '+60', country: 'MY', flag: '🇲🇾', name: 'Malaysia' },
    { code: '+960', country: 'MV', flag: '🇲🇻', name: 'Maldives' },
    { code: '+223', country: 'ML', flag: '🇲🇱', name: 'Mali' },
    { code: '+356', country: 'MT', flag: '🇲🇹', name: 'Malta' },
    { code: '+692', country: 'MH', flag: '🇲🇭', name: 'Marshall Islands' },
    { code: '+596', country: 'MQ', flag: '🇲🇶', name: 'Martinique' },
    { code: '+222', country: 'MR', flag: '🇲🇷', name: 'Mauritania' },
    { code: '+230', country: 'MU', flag: '🇲🇺', name: 'Mauritius' },
    { code: '+262', country: 'YT', flag: '🇾🇹', name: 'Mayotte' },
    { code: '+52', country: 'MX', flag: '🇲🇽', name: 'Mexico' },
    { code: '+691', country: 'FM', flag: '🇫🇲', name: 'Micronesia' },
    { code: '+373', country: 'MD', flag: '🇲🇩', name: 'Moldova' },
    { code: '+377', country: 'MC', flag: '🇲🇨', name: 'Monaco' },
    { code: '+976', country: 'MN', flag: '🇲🇳', name: 'Mongolia' },
    { code: '+382', country: 'ME', flag: '🇲🇪', name: 'Montenegro' },
    { code: '+1664', country: 'MS', flag: '🇲🇸', name: 'Montserrat' },
    { code: '+212', country: 'MA', flag: '🇲🇦', name: 'Morocco' },
    { code: '+258', country: 'MZ', flag: '🇲🇿', name: 'Mozambique' },
    { code: '+95', country: 'MM', flag: '🇲🇲', name: 'Myanmar' },
    { code: '+264', country: 'NA', flag: '🇳🇦', name: 'Namibia' },
    { code: '+674', country: 'NR', flag: '🇳🇷', name: 'Nauru' },
    { code: '+977', country: 'NP', flag: '🇳🇵', name: 'Nepal' },
    { code: '+31', country: 'NL', flag: '🇳🇱', name: 'Netherlands' },
    { code: '+687', country: 'NC', flag: '🇳🇨', name: 'New Caledonia' },
    { code: '+64', country: 'NZ', flag: '🇳🇿', name: 'New Zealand' },
    { code: '+505', country: 'NI', flag: '🇳🇮', name: 'Nicaragua' },
    { code: '+227', country: 'NE', flag: '🇳🇪', name: 'Niger' },
    { code: '+234', country: 'NG', flag: '🇳🇬', name: 'Nigeria' },
    { code: '+683', country: 'NU', flag: '🇳🇺', name: 'Niue' },
    { code: '+672', country: 'NF', flag: '🇳🇫', name: 'Norfolk Island' },
    { code: '+1670', country: 'MP', flag: '🇲🇵', name: 'Northern Mariana Islands' },
    { code: '+47', country: 'NO', flag: '🇳🇴', name: 'Norway' },
    { code: '+968', country: 'OM', flag: '🇴🇲', name: 'Oman' },
    { code: '+92', country: 'PK', flag: '🇵🇰', name: 'Pakistan' },
    { code: '+680', country: 'PW', flag: '🇵🇼', name: 'Palau' },
    { code: '+970', country: 'PS', flag: '🇵🇸', name: 'Palestine' },
    { code: '+507', country: 'PA', flag: '🇵🇦', name: 'Panama' },
    { code: '+675', country: 'PG', flag: '🇵🇬', name: 'Papua New Guinea' },
    { code: '+595', country: 'PY', flag: '🇵🇾', name: 'Paraguay' },
    { code: '+51', country: 'PE', flag: '🇵🇪', name: 'Peru' },
    { code: '+63', country: 'PH', flag: '🇵🇭', name: 'Philippines' },
    { code: '+64', country: 'PN', flag: '🇵🇳', name: 'Pitcairn Islands' },
    { code: '+48', country: 'PL', flag: '🇵🇱', name: 'Poland' },
    { code: '+351', country: 'PT', flag: '🇵🇹', name: 'Portugal' },
    { code: '+1787', country: 'PR', flag: '🇵🇷', name: 'Puerto Rico' },
    { code: '+974', country: 'QA', flag: '🇶🇦', name: 'Qatar' },
    { code: '+262', country: 'RE', flag: '🇷🇪', name: 'Réunion' },
    { code: '+40', country: 'RO', flag: '🇷🇴', name: 'Romania' },
    { code: '+7', country: 'RU', flag: '🇷🇺', name: 'Russia' },
    { code: '+250', country: 'RW', flag: '🇷🇼', name: 'Rwanda' },
    { code: '+290', country: 'SH', flag: '🇸🇭', name: 'Saint Helena' },
    { code: '+1869', country: 'KN', flag: '🇰🇳', name: 'Saint Kitts and Nevis' },
    { code: '+1758', country: 'LC', flag: '🇱🇨', name: 'Saint Lucia' },
    { code: '+508', country: 'PM', flag: '🇵🇲', name: 'Saint Pierre and Miquelon' },
    { code: '+1784', country: 'VC', flag: '🇻🇨', name: 'Saint Vincent and the Grenadines' },
    { code: '+685', country: 'WS', flag: '🇼🇸', name: 'Samoa' },
    { code: '+378', country: 'SM', flag: '🇸🇲', name: 'San Marino' },
    { code: '+239', country: 'ST', flag: '🇸🇹', name: 'São Tomé and Príncipe' },
    { code: '+966', country: 'SA', flag: '🇸🇦', name: 'Saudi Arabia' },
    { code: '+221', country: 'SN', flag: '🇸🇳', name: 'Senegal' },
    { code: '+381', country: 'RS', flag: '🇷🇸', name: 'Serbia' },
    { code: '+248', country: 'SC', flag: '🇸🇨', name: 'Seychelles' },
    { code: '+232', country: 'SL', flag: '🇸🇱', name: 'Sierra Leone' },
    { code: '+65', country: 'SG', flag: '🇸🇬', name: 'Singapore' },
    { code: '+1721', country: 'SX', flag: '🇸🇽', name: 'Sint Maarten' },
    { code: '+421', country: 'SK', flag: '🇸🇰', name: 'Slovakia' },
    { code: '+386', country: 'SI', flag: '🇸🇮', name: 'Slovenia' },
    { code: '+677', country: 'SB', flag: '🇸🇧', name: 'Solomon Islands' },
    { code: '+252', country: 'SO', flag: '🇸🇴', name: 'Somalia' },
    { code: '+27', country: 'ZA', flag: '🇿🇦', name: 'South Africa' },
    { code: '+211', country: 'SS', flag: '🇸🇸', name: 'South Sudan' },
    { code: '+34', country: 'ES', flag: '🇪🇸', name: 'Spain' },
    { code: '+94', country: 'LK', flag: '🇱🇰', name: 'Sri Lanka' },
    { code: '+249', country: 'SD', flag: '🇸🇩', name: 'Sudan' },
    { code: '+597', country: 'SR', flag: '🇸🇷', name: 'Suriname' },
    { code: '+47', country: 'SJ', flag: '🇸🇯', name: 'Svalbard and Jan Mayen' },
    { code: '+268', country: 'SZ', flag: '🇸🇿', name: 'Eswatini' },
    { code: '+46', country: 'SE', flag: '🇸🇪', name: 'Sweden' },
    { code: '+41', country: 'CH', flag: '🇨🇭', name: 'Switzerland' },
    { code: '+963', country: 'SY', flag: '🇸🇾', name: 'Syria' },
    { code: '+886', country: 'TW', flag: '🇹🇼', name: 'Taiwan' },
    { code: '+992', country: 'TJ', flag: '🇹🇯', name: 'Tajikistan' },
    { code: '+255', country: 'TZ', flag: '🇹🇿', name: 'Tanzania' },
    { code: '+66', country: 'TH', flag: '🇹🇭', name: 'Thailand' },
    { code: '+670', country: 'TL', flag: '🇹🇱', name: 'Timor-Leste' },
    { code: '+228', country: 'TG', flag: '🇹🇬', name: 'Togo' },
    { code: '+690', country: 'TK', flag: '🇹🇰', name: 'Tokelau' },
    { code: '+676', country: 'TO', flag: '🇹🇴', name: 'Tonga' },
    { code: '+1868', country: 'TT', flag: '🇹🇹', name: 'Trinidad and Tobago' },
    { code: '+216', country: 'TN', flag: '🇹🇳', name: 'Tunisia' },
    { code: '+90', country: 'TR', flag: '🇹🇷', name: 'Turkey' },
    { code: '+993', country: 'TM', flag: '🇹🇲', name: 'Turkmenistan' },
    { code: '+1649', country: 'TC', flag: '🇹🇨', name: 'Turks and Caicos Islands' },
    { code: '+688', country: 'TV', flag: '🇹🇻', name: 'Tuvalu' },
    { code: '+256', country: 'UG', flag: '🇺🇬', name: 'Uganda' },
    { code: '+380', country: 'UA', flag: '🇺🇦', name: 'Ukraine' },
    { code: '+971', country: 'AE', flag: '🇦🇪', name: 'United Arab Emirates' },
    { code: '+44', country: 'GB', flag: '🇬🇧', name: 'United Kingdom' },
    { code: '+1', country: 'US', flag: '🇺🇸', name: 'United States' },
    { code: '+598', country: 'UY', flag: '🇺🇾', name: 'Uruguay' },
    { code: '+998', country: 'UZ', flag: '🇺🇿', name: 'Uzbekistan' },
    { code: '+678', country: 'VU', flag: '🇻🇺', name: 'Vanuatu' },
    { code: '+379', country: 'VA', flag: '🇻🇦', name: 'Vatican City' },
    { code: '+58', country: 'VE', flag: '🇻🇪', name: 'Venezuela' },
    { code: '+84', country: 'VN', flag: '🇻🇳', name: 'Vietnam' },
    { code: '+1284', country: 'VG', flag: '🇻🇬', name: 'British Virgin Islands' },
    { code: '+1340', country: 'VI', flag: '🇻🇮', name: 'U.S. Virgin Islands' },
    { code: '+681', country: 'WF', flag: '🇼🇫', name: 'Wallis and Futuna' },
    { code: '+212', country: 'EH', flag: '🇪🇭', name: 'Western Sahara' },
    { code: '+967', country: 'YE', flag: '🇾🇪', name: 'Yemen' },
    { code: '+260', country: 'ZM', flag: '🇿🇲', name: 'Zambia' },
    { code: '+263', country: 'ZW', flag: '🇿🇼', name: 'Zimbabwe' }
  ];
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();
  const { settings, loading: settingsLoading, settingsLoaded, safeSettings } = useSettings();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // Detect user's country based on IP address
  useEffect(() => {
    const detectUserCountry = async () => {
      try {
        setIsDetectingLocation(true);
        
        // Try multiple IP geolocation services for better reliability
        const services = [
          { url: 'https://ipapi.co/json/', fields: ['country_code'] },
          { url: 'https://ip-api.com/json/', fields: ['countryCode'] },
          { url: 'https://ipinfo.io/json', fields: ['country'] },
          { url: 'https://api.country.is/', fields: ['country'] }
        ];
        
        let detectedCountry = null;
        
        // Set a timeout for the entire detection process
        const detectionTimeout = new Promise((_, reject) =>
          setTimeout(() => reject(new Error('Detection timeout')), 5000)
        );
        
        const detectionPromise = (async () => {
          for (const service of services) {
            try {
              const controller = new AbortController();
              const timeoutId = setTimeout(() => controller.abort(), 3000);
              
              const response = await fetch(service.url, {
                signal: controller.signal,
                headers: {
                  'Accept': 'application/json',
                }
              });
              
              clearTimeout(timeoutId);
              
              if (response.ok) {
                const data = await response.json();
                
                // Try different field names based on service
                for (const field of service.fields) {
                  const countryCode = data[field];
                  if (countryCode && typeof countryCode === 'string') {
                    detectedCountry = countryCode.toUpperCase();
                    break;
                  }
                }
                
                if (detectedCountry) {
                  console.log(`Country detected from ${service.url}:`, detectedCountry);
                  break; // Success, stop trying other services
                }
              }
            } catch (error) {
              if (error.name === 'AbortError') {
                console.warn(`Request to ${service.url} timed out`);
              } else {
                console.warn(`Failed to detect location from ${service.url}:`, error.message);
              }
              // Continue to next service
            }
          }
          return detectedCountry;
        })();
        
        // Race between detection and timeout
        detectedCountry = await Promise.race([detectionPromise, detectionTimeout]);
        
        if (detectedCountry) {
          // Find the phone code for the detected country
          const countryData = countryCodes.find(country => country.country === detectedCountry);
          if (countryData) {
            setFormData(prev => ({
              ...prev,
              countryCode: countryData.code
            }));
            console.log(`Country code set to ${countryData.code} for ${countryData.name}`);
          } else {
            console.warn(`No phone code found for country: ${detectedCountry}`);
          }
        } else {
          console.log('Could not detect country, using default +1');
        }
      } catch (error) {
        console.warn('Failed to detect user location:', error.message);
        // Keep default +1 if detection fails
      } finally {
        setIsDetectingLocation(false);
      }
    };
    
    // Only run detection if we're still on the default country code
    if (formData.countryCode === '+1') {
      detectUserCountry();
    } else {
      setIsDetectingLocation(false);
    }
  }, []); // Run once on component mount

  // Filter countries based on search
  const filteredCountries = countryCodes.filter(country =>
    country.name.toLowerCase().includes(countrySearch.toLowerCase()) ||
    country.code.includes(countrySearch) ||
    country.country.toLowerCase().includes(countrySearch.toLowerCase())
  );

  // Close country dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showCountryDropdown && !event.target.closest('.country-dropdown')) {
        setShowCountryDropdown(false);
        setCountrySearch('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showCountryDropdown]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      setLoading(false);
      return;
    }
    
    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters long');
      setLoading(false);
      return;
    }

    if (formData.fullName.length < 2) {
      setError('Full name must be at least 2 characters long');
      setLoading(false);
      return;
    }

    if (formData.companyName.length < 2) {
      setError('Company name must be at least 2 characters long');
      setLoading(false);
      return;
    }

    if (formData.phoneNumber.length < 10) {
      setError('Phone number must be at least 10 characters long');
      setLoading(false);
      return;
    }

    const result = await register(
      formData.email,
      formData.password,
      formData.fullName,
      formData.companyName,
      `${formData.countryCode}${formData.phoneNumber}`
    );
    
    if (result.success) {
      if (result.verification_required) {
        // Navigate to verification pending page
        navigate('/verification-pending', {
          state: {
            message: result.message || 'Registration successful! Please check your email to verify your account.',
            email: result.email || formData.email,
            fromRegistration: true
          }
        });
      } else {
        // Legacy: direct login (should not happen with new flow)
        navigate('/dashboard');
      }
    } else {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-card max-w-lg">
        <div className="text-center mb-10">
          <div className="flex justify-center items-center mb-6">
            {!settingsLoading && settings?.product_logo ? (
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-r from-green-500 to-blue-600 rounded-2xl blur opacity-20"></div>
                <img 
                  src={settings.product_logo} 
                  alt={settings.product_name}
                  className="mx-auto h-16 w-auto relative z-10"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
            ) : (
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-r from-green-500 to-blue-600 rounded-2xl blur opacity-20"></div>
                <div className="relative z-10 bg-gradient-to-r from-green-500 to-blue-600 text-white p-4 rounded-2xl shadow-lg">
                  <UserPlus size={32} />
                </div>
              </div>
            )}
          </div>
          <div className={`app-name-container ${settingsLoaded ? 'loaded' : ''}`}>
            <h1 className="text-3xl font-bold text-gray-800 mb-3">
              {safeSettings?.product_name}
            </h1>
          </div>
          {!settingsLoaded && (
            <div className="app-name-placeholder mb-3" style={{height: '2.5rem'}}></div>
          )}
          <div className="flex items-center justify-center gap-2 mb-2">
            <Globe size={18} className="text-green-600" />
            <p className="text-gray-600 font-medium">Join our community</p>
          </div>
          <p className="text-gray-500 text-sm">Create your account to get started</p>
        </div>

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-1">
              <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                <User size={16} className="text-green-600" />
                Full Name
              </label>
              <div className="relative">
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="Enter your full name"
                  required
                />
                <User className="input-icon" size={20} />
              </div>
            </div>

            <div className="space-y-1">
              <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                <Building size={16} className="text-green-600" />
                Company Name
              </label>
              <div className="relative">
                <input
                  type="text"
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="Enter your company name"
                  required
                />
                <Building className="input-icon" size={20} />
              </div>
            </div>
          </div>

          <div className="space-y-1">
            <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
              <Mail size={16} className="text-green-600" />
              Email Address
            </label>
            <div className="relative">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="form-input"
                placeholder="Enter your email address"
                required
              />
              <Mail className="input-icon" size={20} />
            </div>
          </div>

          <div className="space-y-1">
            <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
              <Phone size={16} className="text-green-600" />
              Phone Number
              {!isDetectingLocation && formData.countryCode !== '+1' && (
                <span className="text-xs text-green-600 bg-green-50 px-2 py-1 rounded-full ml-auto">
                  Auto-detected
                </span>
              )}
            </label>
            <div className="flex gap-2">
              <div className="relative country-dropdown">
                <button
                  type="button"
                  onClick={() => setShowCountryDropdown(!showCountryDropdown)}
                  className="flex items-center gap-2 px-3 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl hover:border-gray-300 transition-colors min-w-[100px] justify-between"
                  disabled={isDetectingLocation}
                >
                  {isDetectingLocation ? (
                    <span className="flex items-center gap-2">
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-green-600"></div>
                      <span className="text-sm text-gray-500">Detecting...</span>
                    </span>
                  ) : (
                    <span className="flex items-center gap-2">
                      <span className="text-lg">{countryCodes.find(c => c.code === formData.countryCode)?.flag || '🌍'}</span>
                      <span className="text-sm font-medium">{formData.countryCode}</span>
                    </span>
                  )}
                  <ChevronDown size={16} className={`transition-transform ${showCountryDropdown ? 'rotate-180' : ''}`} />
                </button>
                
                {showCountryDropdown && (
                  <div className="absolute top-full left-0 right-0 mt-1 bg-white border-2 border-gray-200 rounded-xl shadow-lg z-50">
                    <div className="p-3 border-b border-gray-200">
                      <input
                        type="text"
                        placeholder="Search countries..."
                        value={countrySearch}
                        onChange={(e) => setCountrySearch(e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                        autoFocus
                      />
                    </div>
                    <div className="max-h-48 overflow-y-auto">
                      {filteredCountries.length > 0 ? (
                        filteredCountries.map((country) => (
                          <button
                            key={country.code}
                            type="button"
                            onClick={() => {
                              setFormData({...formData, countryCode: country.code});
                              setShowCountryDropdown(false);
                              setCountrySearch('');
                            }}
                            className="w-full flex items-center gap-3 px-3 py-2 hover:bg-gray-50 text-left transition-colors"
                          >
                            <span className="text-lg">{country.flag}</span>
                            <span className="text-sm font-medium min-w-[60px]">{country.code}</span>
                            <span className="text-sm text-gray-600 truncate">{country.name}</span>
                          </button>
                        ))
                      ) : (
                        <div className="px-3 py-4 text-sm text-gray-500 text-center">
                          No countries found matching "{countrySearch}"
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              
              <div className="relative flex-1">
                <input
                  type="tel"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  className="form-input w-full"
                  placeholder="Enter your phone number"
                  required
                />
                <Phone className="input-icon" size={20} />
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-1">
              <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                <Lock size={16} className="text-green-600" />
                Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className="form-input pr-12"
                  placeholder="Create a secure password"
                  required
                />
                <Lock className="input-icon" size={20} />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-green-600 transition-colors duration-200"
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>

            <div className="space-y-1">
              <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                <Lock size={16} className="text-green-600" />
                Confirm Password
              </label>
              <div className="relative">
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  className="form-input pr-12"
                  placeholder="Confirm your password"
                  required
                />
                <Lock className="input-icon" size={20} />
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-green-600 transition-colors duration-200"
                >
                  {showConfirmPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>
          </div>

          <button
            type="submit"
            className="btn-primary w-full mt-8"
            disabled={loading}
          >
            {loading ? (
              <div className="flex items-center justify-center gap-3">
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                <span>Creating your account...</span>
              </div>
            ) : (
              <div className="flex items-center justify-center gap-2">
                <UserPlus size={20} />
                <span>Create My Account</span>
              </div>
            )}
          </button>
        </form>

        <p className="text-center mt-6 text-gray-600">
          Already have an account?{' '}
          <Link to="/login" className="text-purple-600 hover:text-purple-500 font-medium">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Register;